/**
***************************************************************************
* NAME 			: IndustryNewsSummary
* PROPS	 		: None
* RETURNS 		: Display the industry news on the dashboard
* LAST MODIFIED 	: March 21, 2024
***************************************************************************
*/

import { useState, useEffect, useContext } from 'react';
import { Link } from 'react-router-dom';
import AuthContext from '../../../context/auth-context';
import NotificationContext from '../../../context/notification-context';
import useHttp from '../../../hooks/use-http';
import LoadingSpinner from '../../../components/UI/LoadingSpinner';
import { getIndustryNews } from '../../../api/industry-news';

import { Splide, SplideSlide } from '@splidejs/react-splide';
import '@splidejs/react-splide/css';

const IndustryNewsSummary = () => {
	const authCtx = useContext(AuthContext);
	const notifyCtx = useContext(NotificationContext);

	const [news, setNews] = useState([]);
	const [errorMessage, setErrorMessage] = useState("");
	const [isLoading, setIsLoading] = useState(true);

	const { sendRequest, status, data, error } = useHttp(getIndustryNews);

	useEffect(() => {
		if (status === 'completed') {
			if (error !== null) {
				// notifyCtx.displayNotification(
				// 	"ERROR",
				// 	error
				// )
				setErrorMessage(error);
			} else if (!data['success']) {
				// notifyCtx.displayNotification(
				// 	"ERROR",
				// 	data['status_code'] + ': ' + data['status']
				// )
				setErrorMessage(data['status_code'] + ': ' + data['status']);
			} else {
				// console.log('NEWS DATA');
				// console.log(data['data']);

				setErrorMessage("");
				setNews(data['data']);
			}
			setIsLoading(false);

			// Reset timeout
			// authCtx.updateExpiration();
		}
	}, [status, error, data]);

	useEffect(() => {
		const requestData = {
			token: authCtx.token,
			dashboard: authCtx.dashboard,
			top: 5,
			display: "summary"
		};

		sendRequest(requestData);
	}, [sendRequest]);

	return (
		<>
			{ isLoading && <LoadingSpinner /> }
			{ !isLoading && errorMessage &&
				<article>
					<div className="article_copy">
						<p>{errorMessage}</p>
					</div>
				</article>
			}

			{ !isLoading && !errorMessage && (news.length == 0) &&
				<article>
					<div className="article_copy">
						<p>No industry news items to display</p>
					</div>
				</article>
			}
			{ !isLoading && !errorMessage && (news.length > 0) &&
				<>
					<Splide options={ { rewind: true } } aria-label="Industry News">
						{news.map((article) => 
							<SplideSlide key={article.id}>
								<article>
									<div className="article_copy">
										<h3 className="article_head"><Link to={article.url} className="external" target="_blank">{article.title}</Link> ({article.displayNewsMomentAbbr})</h3>
										<p><em>{article.lastAction} on {article.displayLastActionMoment}</em></p>
									</div>
								</article>
							</SplideSlide>
						)}
					</Splide>

					<p><Link to="/industry-news/">See all</Link></p>
				</>
			}
		</>
	)
}

export default IndustryNewsSummary;